import { APIProvider } from "@vis.gl/react-google-maps"
import { Effect } from "effect"
import { StrictMode, startTransition } from "react"
import { hydrateRoot } from "react-dom/client"
import { HydratedRouter } from "react-router/dom"

const hydrateEffect = Effect.sync(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
          <HydratedRouter />
        </APIProvider>
      </StrictMode>,
    )
  })
})

Effect.runSync(hydrateEffect)
